export { configure } from './common/utils/config';
export { getResourceTimings } from './main';
export { startResourceTimingBuffer } from './utils';